import { parse, type DocumentNode } from 'graphql';

/**
 * Construit la query d'un endpoint `<collection>Options`.
 *
 * Tous ces endpoints partagent la MÊME signature et le MÊME type de retour : écrire la query à la main
 * pour chaque collection ne ferait que recopier treize fois le même bloc. On la fabrique donc à partir
 * du seul élément qui change — le nom du champ — et de son type de périmètre.
 *
 * Le champ est **aliasé en `result`** : la réponse a la même forme quelle que soit la collection, donc
 * une source n'a plus besoin de fournir un accesseur pour aller chercher son champ.
 *
 * `parse()` et non le tag `gql` : le tag est scruté par graphql-codegen, qui ne sait pas lire une
 * interpolation. En contrepartie, ces documents ne sont plus validés contre le schéma à la génération
 * — c'est `entity-sources/sources.test.ts` qui tient ce rôle.
 */
export function buildEntityOptionsQuery(field: string, scopeType?: string): DocumentNode {
    const operationName = field.replace(/([A-Z])/g, '_$1').toUpperCase();
    const scopeVariable = scopeType ? `, $scope: ${scopeType}` : '';
    const scopeArgument = scopeType ? ', scope: $scope' : '';

    return parse(`
        query ${operationName}($search: String, $ids: [ID!], $limit: Int${scopeVariable}) {
            result: ${field}(search: $search, ids: $ids, limit: $limit${scopeArgument}) {
                hasMore
                options {
                    value
                    label
                    hint
                    disabled
                }
            }
        }
    `);
}
